import { gql } from '@apollo/client';

export const GET_PAGINATED_ROOMS_BY_TYPE = gql`
  query GET_PAGINATED_ROOMS_BY_TYPE($limit: Float!, $page: Float!, $chatType: String) {
    getPaginatedRoomsByType(limit: $limit, page: $page, chatType: $chatType) {
      __typename
      id
      createdAt
      recentMessage
      hasUnreadMessage
      chatType

      owner {
        id
        email
        avatar {
          fileUrl
        }

        profile {
          id
          name
        }
      }

      members {
        email
        id
        avatar {
          fileUrl
        }
        profile {
          id
          name
        }
      }
    }
  }
`;